/**
 * T076: Prompt New Page
 * Page for creating a new prompt
 */

import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { PromptForm, type PromptFormSubmitValues } from '@/components/prompts/prompt-form'
import { useCreatePrompt } from '@/hooks/useCreatePrompt'
import type { CreatePromptInput } from '@/services/prompts'

export function PromptNewPage() {
  const createPrompt = useCreatePrompt()

  const handleSubmit = (values: PromptFormSubmitValues) => {
    const input: CreatePromptInput = {
      title: values.title,
      content: values.content,
      category_id: values.category_id,
      tag_ids: values.tag_ids,
    }
    createPrompt.mutate(input)
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/prompts">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Link>
        </Button>
        <h1 className="text-2xl font-bold">New Prompt</h1>
      </div>

      <PromptForm
        onSubmit={handleSubmit}
        isSubmitting={createPrompt.isPending}
        submitLabel="Create Prompt"
      />

      {createPrompt.error && (
        <div className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
          {createPrompt.error.message}
        </div>
      )}
    </div>
  )
}
